import { Paper } from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { Spinner, Table } from "react-bootstrap";
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
const EnterHifzResult = () => {
  const pageStyle = `
  @font-face {
    font-family: 'Jameel Noori Nastaleeq';
    src: local("Jameel Noori Nastaleeq"), url('/src/app/fonts/JameelNooriNastaleeqRegular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @page {
    margin-left: 1.5in;
    size: legal landscape !important;
  }

  body {
    font-family: 'Jameel Noori Nastaleeq', serif;
    direction: rtl;
  }
`;

  const headCellStyle = {
    fontSize: "18px",
    border: "1px solid black",
    padding: "10px",
    whiteSpace: "noraml",
    color: "black",
    textAlign: "center",
  };

  const headCellStyleVertical = {
    fontSize: "18px",
    border: "1px solid black",
    padding: "10px", // Increased padding for better spacing
    writingMode: "vertical-rl", // This rotates the text vertically
    whiteSpace: "normal", // Ensures text wraps normally if it exceeds the space
    color: "black",
    textAlign: "center",
  };

  const bodyCellStyle = {
    fontSize: "14px",
    border: "1px solid black",
    padding: "1px",
    whiteSpace: "noraml",
    color: "black",
  };

  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const getBranchUrl = localStorage.getItem("branchUrl");
  const [allsessions, setallsessions] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [selectedcampus, setselectedcampus] = useState("");
  const [currentsession, setcurrentsession] = useState("");
  const [selectedsection, setselectedsection] = useState("");
  const [examName, setExamName] = useState("");
  const [educationType, setEducationType] = useState(2);

  const [selectedExamType, setSelectedExamType] = useState("");
  const [selectedclass, setselectedclass] = useState("");

  const [allclasses, setallclasses] = useState([]);
  const [allCampusSections, setallCampusSections] = useState([]);
  const [totalMarks, setTotalMarks] = useState(100);
  const [currentDate, setCurrentDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [updateloading, setupdateloading] = useState(false);
  const [allExamList, setAllExamList] = useState([]);
  const [loading, setloading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [examDetails, setExamDetails] = useState([]);
  const [printEmpty, setPrintEmpty] = useState(false);

  //printing states
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const [selectedStudents, setSelectedStudents] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const firstTimeLoad = useRef(false);
  const [sendLoading, setSendLoading] = useState(false);

  const [sendTestMessageModal, setSendTestMessageModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  useEffect(() => {
    // if (!firstTimeLoad.current) {
    //   firstTimeLoad.current = true;
    getAllSessions();
    getSettingData();
    // }

    // if (searchClicked.current) {
    //   searchClicked.current = false;
    //   setAllCheckboxes(true);
    // } else {
    //   checkAllCheckBoxes();
    // }
    //   }, [[], selectedStudents]);
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setcurrentsession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = async (id) => {
    setselectedcampus(id);
    getCampusClasses(id);
    setallclasses([]);
    setselectedclass("");
    setallCampusSections([]);
    setselectedsection("");
  };

  const getCampusClasses = (id) => {
    fetch(`${baseUrl}/campusclass/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.payload) {
          setallclasses(data.payload);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onClassChange = (id) => {
    setselectedclass(id);
    setallCampusSections([]);
    setselectedsection("");

    fetch(`${baseUrl}/class_section/${selectedcampus}/${educationType}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallCampusSections([...data.payload]);
      })
      .catch((err) => {
        console.log("section error", err);
      });
  };

  const createExamResult = () => {
    if (selectedExamType == "" || selectedcampus == "") {
      return alert.error("Please select all fileds");
    }

    if (selectedsection == "" || selectedclass == "") {
      return alert.error("Please select class/section");
    }

    if (totalMarks == 0) {
      return alert.error("Please Enter Total Marks");
    }

    if (examName == "") {
      return alert.error("Please Enter Exam Name");
    }

    setAllExamList([]);
    setExamDetails([]);
    setAddLoading(true);

    let data = {
      year_id: currentsession,
      campus_id: selectedcampus,
      education_type: educationType,
      student_class_id: selectedclass,
      global_section_id: selectedsection,
      name: examName,
      type: selectedExamType,
      total_marks: totalMarks,
      date: currentDate,
    };

    fetch(`${baseUrl}/hifz-exams`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          const res = data.payload[0].hifz_exam_results.sort(
            (a, b) => a?.student?.admission_id - b?.student?.admission_id
          );
          setAllExamList(res);
          setExamDetails(data.payload[0]);

          alert.success("Hifz Exam Successfully Created");
          setAddLoading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            toast.error(msg);
            setAddLoading(false);
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setAddLoading(false);
      });
  };

  const getExamResult = () => {
    if (
      currentsession == "" ||
      selectedcampus == "" ||
      selectedclass == "" ||
      selectedsection == "" ||
      selectedExamType == "" ||
      currentDate == ""
    ) {
      return alert.error("Please select all fileds");
    }

    setAllExamList([]);
    setExamDetails([]);
    setloading(true);

    fetch(
      `${baseUrl}/hifz-exams/${currentsession}/${selectedcampus}/${selectedclass}/${selectedsection}/${selectedExamType}/${currentDate}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
          branchUrl: getBranchUrl,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          const res = data.payload[0].hifz_exam_results.sort(
            (a, b) => a?.student?.admission_id - b?.student?.admission_id
          );
          console.log(res);
          setAllExamList(res);
          setExamDetails(data.payload[0]);
          setloading(false);
        } else if (!data.metadata.success) {
          alert.error(data.metadata.message);
          setloading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateResult = () => {
    setupdateloading(true);

    const updatedList = allExamList.map((ele) => ({
      ...ele,
      sabqi_para: ele.sabqi_para ?? "---",
      manzal: ele.manzal ?? "---",
      remarks: ele.remarks ?? "---",
      present_completed_paray: ele.present_completed_paray || 0,
      tajweed: ele.tajweed || 0,
      tarseel: ele.tarseel || 0,
      diary: ele.diary || 0,
      moral_training: ele.moral_training || 0,
      lesson_one_mistakes: ele.lesson_one_mistakes || 0,
      lesson_one_numbers: ele.lesson_one_numbers || 0,
      lesson_two_mistakes: ele.lesson_two_mistakes || 0,
      lesson_two_numbers: ele.lesson_two_numbers || 0,
      lesson_three_mistakes: ele.lesson_three_mistakes || 0,
      lesson_three_numbers: ele.lesson_three_numbers || 0,
      lesson_four_mistakes: ele.lesson_four_mistakes || 0,
      lesson_four_numbers: ele.lesson_four_numbers || 0,
    }));

    let hifz_exam_results = { hifz_exam_results: updatedList };

    fetch(`${baseUrl}/update-hifz-exam-results`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
        branchUrl: getBranchUrl,
      },
      body: JSON.stringify(hifz_exam_results),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          alert.success("Exam update successfully");
          setupdateloading(false);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg);
            setupdateloading(false);
          });
        }
      })
      .catch((err) => {
        setupdateloading(false);

        console.log(err);
      });
  };

  // Handle Test Checkbox
  //   const handleMainCheckboxClick = () => {
  //     if (mainCheckBoxChecked) setAllCheckboxes(false);
  //     else setAllCheckboxes(true);
  //   };

  //   const setAllCheckboxes = (value) => {
  //     setmaincheckboxChecked(value);
  //     if (value) {
  //       setSelectedStudents([]);
  //     }

  //     allTestList.map((item, i) => {
  //       item.checked = value;
  //       if (!value) {
  //         RemoveSelectedTest(item);
  //       } else {
  //         AddSelectedTest(item);
  //       }
  //     });
  //   };

  //   const checkAllCheckBoxes = () => {
  //     if (allTestList.length == selectedStudents.length) {
  //       setmaincheckboxChecked(true);
  //     } else if (mainCheckBoxChecked) {
  //       setmaincheckboxChecked(false);
  //     }
  //   };

  //   const handleChallansCheckBoxClick = (e, index) => {
  //     allTestList.map((item, i) => {
  //       if (item.id == index) {
  //         item.checked = !item.checked;

  //         if (item.checked) {
  //           AddSelectedTest(item);
  //         } else {
  //           RemoveSelectedTest(item);
  //         }
  //       }
  //     });
  //   };

  //   const AddSelectedTest = (item) => {
  //     setSelectedStudents((prevSelectedTests) => [
  //       ...prevSelectedTests,
  //       item.student_id,
  //     ]);
  //   };

  //   const RemoveSelectedTest = (item) => {
  //     setSelectedStudents((prevSelectedTests) =>
  //       prevSelectedTests.filter((id) => id !== item.student_id)
  //     );
  //   };

  //   const sendNoticationModal = () => {
  //     if (selectedStudents == "") {
  //       return alert.error("Please Select Some Students");
  //     }
  //     setNotificationModal(true);
  //   };

  //   const sendNotification = () => {
  //     setSendLoading(true);
  //     console.log(selectedStudents);
  //     if (selectedStudents.length > 0) {
  //       let FinalNotificationArray = [];
  //       const res = allTestList.filter((item) =>
  //         selectedStudents.includes(item.student_id)
  //       );
  //       console.log(res, "after filter");
  //       res.map((result) => {
  //         // const transformedArray = result.student_result.map((sub) => {
  //         //   return `${sub.subject.name}:${sub.gain_marks}/${sub.full_marks}`;
  //         // });
  //         // const resultDec = transformedArray.join(" , ");
  //         FinalNotificationArray.push({
  //           title: "Daily Test",
  //           description: `Dear Parents/Guardian, ${result.student.name} (${result.student.admission_id}) ${testDetails.test_type?.name} Test Result: ${result?.gain_marks}/${testDetails?.full_marks} (${testDetails?.date})`,
  //           id: result.student.notification_id,
  //         });
  //       });
  //       console.log(FinalNotificationArray, "finnaly");
  //       sendTestResultNotifications(FinalNotificationArray);
  //       alert.success("Notification Successfully Sent");
  //       setSendLoading(false);
  //       setAllCheckboxes(false);
  //       setNotificationModal(false);
  //     } else {
  //       setSendLoading(false);
  //       alert.error("Please select at least one student");
  //       setNotificationModal(false);
  //     }
  //   };

  //   const sendTestModal = () => {
  //     if (selectedStudents == "") {
  //       return alert.error("Please Select Some Students");
  //     }
  //     setSendTestMessageModal(true);
  //   };

  //   const sendSingleTestsSMS = () => {
  //     if (selectedStudents == "") {
  //       return alert.error("Please Select Some Students");
  //     }

  //     setSendLoading(true);
  //     let data = {
  //       test_id: testDetails?.id,
  //       student_ids: selectedStudents,
  //     };

  //     fetch(`${baseUrl}/single-test-send-sms`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authtoken}`,
  //       },
  //       body: JSON.stringify(data),
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.metadata.success) {
  //           alert.success("Test Message Sent Successfully");
  //           setSendLoading(false);
  //           setSendTestMessageModal(false);
  //         } else if (!data.metadata.success) {
  //           alert.error(data.metadata.message);
  //           setSendLoading(false);
  //           setSendTestMessageModal(false);
  //         }
  //       })
  //       .catch((err) => {
  //         setSendLoading(false);
  //         setSendTestMessageModal(false);
  //         console.log(err);
  //       });
  //   };
  //printing function

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const onStatusChange = (e, index) => {
    let arr = [...allExamList];
    let newVal = e.target.value;

    arr[index].status = newVal;
    if (newVal != "Present") {
      arr[index].present_completed_paray = 0;
      arr[index].sabqi_para = "---";
      arr[index].manzal = "---";
      arr[index].tajweed = 0;
      arr[index].tarseel = 0;
      arr[index].lesson_one_mistakes = 0;
      arr[index].lesson_one_numbers = 0;
      arr[index].lesson_two_mistakes = 0;
      arr[index].lesson_two_mistakes = 0;
      arr[index].lesson_three_numbers = 0;
      arr[index].lesson_three_numbers = 0;
      arr[index].lesson_four_numbers = 0;
      arr[index].lesson_four_numbers = 0;
      arr[index].moral_training = 0;
      arr[index].diary = 0;
      arr[index].remarks = "---";
    }
    setAllExamList(arr);
  };

  const onChangePresentCompletedParay = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseFloat(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 30) {
      arr[index].present_completed_paray = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].present_completed_paray = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs = useRef([]);
  const handleKeyDown = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs.current.length;
      const nextInput = inputRefs.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeSabqiPara = (e, index) => {
    let arr = [...allExamList];
    let newVal = e.target.value;

    arr[index].sabqi_para = newVal == "" ? "---" : newVal;
    setAllExamList(arr);
  };

  const inputRefs1 = useRef([]);
  const handleKeyDown1 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs1.current.length;
      const nextInput = inputRefs1.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeManzal = (e, index) => {
    let arr = [...allExamList];
    let newVal = e.target.value;

    arr[index].manzal = newVal == "" ? "---" : newVal;
    setAllExamList(arr);
  };

  const inputRefs2 = useRef([]);
  const handleKeyDown2 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs2.current.length;
      const nextInput = inputRefs2.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeTajweed = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 10) {
      arr[index].tajweed = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].tajweed = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs3 = useRef([]);
  const handleKeyDown3 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs3.current.length;
      const nextInput = inputRefs3.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeTarseel = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 10) {
      arr[index].tarseel = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].tarseel = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs4 = useRef([]);
  const handleKeyDown4 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs4.current.length;
      const nextInput = inputRefs4.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonOneMistakes = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_one_mistakes = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_one_mistakes = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs5 = useRef([]);
  const handleKeyDown5 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs5.current.length;
      const nextInput = inputRefs5.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonOneNumbers = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_one_numbers = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_one_numbers = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs6 = useRef([]);
  const handleKeyDown6 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs6.current.length;
      const nextInput = inputRefs6.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonTwoMistakes = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_two_mistakes = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_two_mistakes = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs7 = useRef([]);
  const handleKeyDown7 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs7.current.length;
      const nextInput = inputRefs7.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonTwoNumbers = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_two_numbers = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_two_numbers = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs8 = useRef([]);
  const handleKeyDown8 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs8.current.length;
      const nextInput = inputRefs8.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonThreeMistakes = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_three_mistakes = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_three_mistakes = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs9 = useRef([]);
  const handleKeyDown9 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs9.current.length;
      const nextInput = inputRefs9.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonThreeNumbers = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_three_numbers = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_three_numbers = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs10 = useRef([]);
  const handleKeyDown10 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs10.current.length;
      const nextInput = inputRefs10.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonFourMistakes = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_four_mistakes = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_four_mistakes = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs11 = useRef([]);
  const handleKeyDown11 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs11.current.length;
      const nextInput = inputRefs11.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeLessonFourNumbers = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 15) {
      arr[index].lesson_four_numbers = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].lesson_four_numbers = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs12 = useRef([]);
  const handleKeyDown12 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs12.current.length;
      const nextInput = inputRefs12.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeMoralTraining = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 10) {
      arr[index].moral_training = newVal;
    }

    if (isNaN(newVal) || newVal == "") {
      arr[index].moral_training = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs13 = useRef([]);
  const handleKeyDown13 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs13.current.length;
      const nextInput = inputRefs13.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeDiary = (e, index) => {
    let arr = [...allExamList];
    let newVal = parseInt(e.target.value, 10);

    if (!isNaN(newVal) && newVal <= 10) {
      arr[index].diary = newVal;
    }
    if (isNaN(newVal) || newVal == "") {
      arr[index].diary = 0;
    }
    setAllExamList(arr);
  };

  const inputRefs14 = useRef([]);
  const handleKeyDown14 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs14.current.length;
      const nextInput = inputRefs14.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  const onChangeRemarks = (e, index) => {
    let arr = [...allExamList];
    let newVal = e.target.value;

    arr[index].remarks = newVal == "" ? "---" : newVal;
    setAllExamList(arr);
  };

  const inputRefs15 = useRef([]);
  const handleKeyDown15 = (e, index) => {
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();

      const nextIndex = (index + 1) % inputRefs15.current.length;
      const nextInput = inputRefs15.current[nextIndex];

      if (nextInput) nextInput.focus();
      nextInput.select();
    }
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "20px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => setcurrentsession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentsession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session) => (
                <option key={session.id} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              value={selectedcampus}
              onChange={(e) => onCampusChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>

            <select
              style={{ height: 40 }}
              className="form-select"
              name="class_id"
              value={selectedclass}
              onChange={(e) => onClassChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {allclasses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Education Type</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select"
              name="campus_id"
              value={educationType}
              style={{ height: 40 }}
              aria-label="Default select example"
              onChange={(e) => {
                setEducationType(e.target.value);
              }}
              disabled
            >
              <option value={1}>Education</option>
              <option value={2}>Hifz</option>
            </select>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-3">
            <label>
              <b>Select Section</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>

            <select
              style={{ height: 40 }}
              className="form-select"
              name="class_id"
              value={selectedsection}
              onChange={(e) => setselectedsection(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {allCampusSections.map((sec, index) => (
                <option key={index} value={sec.id}>
                  {sec.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Exam Type</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => {
                setSelectedExamType(e.target.value);
              }}
              className="form-select"
              style={{ height: 40 }}
              value={selectedExamType}
              aria-label="Default select example"
            >
              <option value="">Select Exam Type</option>
              <option value={"Annual"}>Annual</option>
              <option value={"Monthly"}>Monthly</option>
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Enter Exam Name</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={examName}
              onChange={(e) => setExamName(e.target.value)}
              name="total_marks"
              placeholder="Enter Exam Name"
            />
          </div>

          <div className="col-md-3">
            <label>
              <b>Enter Total Marks</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <input
              type="number"
              className="form-control"
              value={totalMarks}
              onChange={(e) => setTotalMarks(e.target.value)}
              name="total_marks"
              placeholder="Enter Total Marks"
              disabled
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-md-3">
            <label className="form-control-label">
              <b>
                Select Date{" "}
                <span style={{ color: "red", fontSize: 12 }}>*</span>
              </b>
            </label>
            <input
              value={currentDate}
              className="form-control"
              onChange={(e) => setCurrentDate(e.target.value)}
              type="date"
            />
          </div>

          <div className="col-md-4 mt-12 d-flex">
            <div className="ml-5">
              <input type="checkbox" style={{ display: "none" }} />
              <label className="checkbox checkbox-single">
                <input
                  checked={printEmpty}
                  type="checkbox"
                  onChange={(e) => setPrintEmpty(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Print Empty
              </label>
            </div>
          </div>
        </div>

        <div
          className="d-flex justify-content-between"
          style={{ marginTop: 20, height: 40 }}
        >
          <div>
            <button
              disabled={loading ? true : false}
              className="btn btn-primary"
              onClick={getExamResult}
            >
              {loading ? "Loading..." : "Get Exam Result"}
            </button>

            {allExamList.length > 0 && (
              <>
                <ReactToPrint
                  pageStyle={pageStyle}
                  documentTitle="Hifz Result"
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-105px mx-2"
                    >
                      {printloading ? "Printing..." : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                {/* <button
                  className="btn btn-primary w-205px mx-2"
                  onClick={sendTestModal}
                  disabled={sendLoading ? true : false}
                >
                  {sendLoading ? "Sending..." : "Send Test SMS"}
                </button>

                <button
                  className="btn btn-primary w-205px mx-2"
                  onClick={sendNoticationModal}
                  disabled={sendLoading ? true : false}
                >
                  {sendLoading ? "Sending..." : "Send Test Notifications"}
                </button> */}
              </>
            )}
          </div>
          <div>
            <button
              disabled={addLoading ? true : false}
              className="btn btn-primary"
              onClick={createExamResult}
            >
              {addLoading ? "Loading..." : "Create Exam Result"}
            </button>
          </div>
        </div>

        {loading ? (
          <div className="row justify-content-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <Table responsive style={{ width: "max-content" }}>
              <thead>
                {allExamList.length > 0 && (
                  <tr>
                    {/* <th style={{ width: "5px" }}>
                    <label className="checkbox checkbox-single">
                      <input
                        type="checkbox"
                        className="form-checkbox"
                        onClick={(e) => {
                          handleMainCheckboxClick();
                        }}
                        checked={mainCheckBoxChecked}
                        readOnly
                      />
                      <span />
                    </label>
                  </th> */}
                    <th
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "white",
                        zIndex: 2,
                        width: 80,
                        minWidth: 80,
                        maxWidth: 80,
                      }}
                    >
                      Sr.No
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        left: 80,
                        background: "white",
                        zIndex: 2,
                        width: 120,
                        minWidth: 120,
                        maxWidth: 120,
                      }}
                    >
                      Admission No
                    </th>
                    <th
                      style={{
                        position: "sticky",
                        left: 200, // 80 + 120
                        background: "white",
                        zIndex: 2,
                        width: 250,
                        minWidth: 250,
                        maxWidth: 250,
                      }}
                    >
                      Student Name
                    </th>

                    <td className="text-center">Exam Type</td>
                    <td className="text-center">Present Complete Paray</td>
                    <td className="text-center">Sabqi Para</td>
                    <td className="text-center">Manzil</td>
                    <td className="text-center">Tajweed</td>
                    <td className="text-center">Tarseel</td>
                    <td className="text-center">Lesson One Mistakes</td>
                    <td className="text-center">Lesson One Numbers</td>
                    <td className="text-center">Lesson Two Mistakes</td>
                    <td className="text-center">Lesson Two Numbers</td>
                    <td className="text-center">Lesson Three Mistakes</td>
                    <td className="text-center">Lesson Three Numbers</td>
                    <td className="text-center">Lesson Four Mistakes</td>
                    <td className="text-center">Lesson Four Numbers</td>
                    <td className="text-center">Moral Training</td>
                    <td className="text-center">Diary</td>
                    <td className="text-center">Remarks</td>
                    <td className="text-center">Status</td>
                  </tr>
                )}
              </thead>
              <tbody>
                {allExamList.length > 0
                  ? allExamList.map((item, index) => (
                      <tr key={item.id}>
                        {/* <td style={{ width: "5px" }}>
                        <label className="checkbox checkbox-single">
                          <input
                            type="checkbox"
                            className="form-checkbox"
                            value={item.id}
                            key={item.id}
                            onClick={(e) => {
                              handleChallansCheckBoxClick(e, item.id);
                            }}
                            checked={item.checked ?? false}
                            readOnly
                          />
                          <span />
                        </label>
                      </td> */}
                        <td
                          style={{
                            position: "sticky",
                            left: 0,
                            background: "white",
                            zIndex: 2,
                            width: 40,
                            minWidth: 40,
                            maxWidth: 40,
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            position: "sticky",
                            left: 80, // Adjust this based on the width of the first column
                            background: "white",
                            zIndex: 2,
                            width: 120,
                            minWidth: 120,
                            maxWidth: 120,
                          }}
                        >
                          {item.student?.admission_id}
                        </td>
                        <td
                          style={{
                            position: "sticky",
                            left: 200, // Adjust this based on cumulative width of first two
                            background: "white",
                            zIndex: 2,
                            width: 250,
                            minWidth: 250,
                            maxWidth: 250,
                          }}
                        >
                          {item.student?.name}
                        </td>
                        <td className="text-center">{examDetails?.type}</td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangePresentCompletedParay(e, index)
                            }
                            value={Math.round(item.present_completed_paray)}
                            placeholder={"Present Completed Paray"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            onChange={(e) => onChangeSabqiPara(e, index)}
                            value={
                              item.sabqi_para == null
                                ? ""
                                : Math.round(item.sabqi_para)
                            }
                            placeholder={"Sabqi Para"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs1.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown1(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            onChange={(e) => onChangeManzal(e, index)}
                            value={
                              item.manzal == null ? "" : Math.round(item.manzal)
                            }
                            placeholder={"Manzal"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs2.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown2(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeTajweed(e, index)}
                            value={Math.round(item.tajweed)}
                            placeholder={"Tajweed"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs3.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown3(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeTarseel(e, index)}
                            value={Math.round(item.tarseel)}
                            placeholder={"Tarseel"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs4.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown4(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonOneMistakes(e, index)
                            }
                            value={Math.round(item.lesson_one_mistakes)}
                            placeholder={"Lesson One Mistakes"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs5.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown5(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeLessonOneNumbers(e, index)}
                            value={Math.round(item.lesson_one_numbers)}
                            placeholder={"Lesson One Numbers"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs6.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown6(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonTwoMistakes(e, index)
                            }
                            value={Math.round(item.lesson_two_mistakes)}
                            placeholder={"Lesson Two Mistakes"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs7.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown7(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeLessonTwoNumbers(e, index)}
                            value={Math.round(item.lesson_two_numbers)}
                            placeholder={"Lesson Two Numbers"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs8.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown8(e, index)}
                          />
                        </td>

                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonThreeMistakes(e, index)
                            }
                            value={Math.round(item.lesson_three_mistakes)}
                            placeholder={"Lesson Three Mistakes"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs9.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown9(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonThreeNumbers(e, index)
                            }
                            value={Math.round(item.lesson_three_numbers)}
                            placeholder={"Lesson Three Numbers"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs10.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown10(e, index)}
                          />
                        </td>

                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonFourMistakes(e, index)
                            }
                            value={Math.round(item.lesson_four_mistakes)}
                            placeholder={"Lesson Four Mistakes"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs11.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown11(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) =>
                              onChangeLessonFourNumbers(e, index)
                            }
                            value={Math.round(item.lesson_four_numbers)}
                            placeholder={"Lesson Four Numbers"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs12.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown12(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeMoralTraining(e, index)}
                            value={Math.round(item.moral_training)}
                            placeholder={"Moral Training"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs13.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown13(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="number"
                            onChange={(e) => onChangeDiary(e, index)}
                            value={Math.round(item.diary)}
                            placeholder={"Diary"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs14.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown14(e, index)}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="text"
                            onChange={(e) => onChangeRemarks(e, index)}
                            value={item.remarks == null ? "" : item.remarks}
                            placeholder={"Remarks"}
                            disabled={item.status !== "Present"}
                            ref={(ref) => (inputRefs15.current[index] = ref)}
                            onKeyDown={(e) => handleKeyDown15(e, index)}
                          />
                        </td>

                        {/* <td className="text-center">
                        <input
                          onChange={(e) => OnchangefullMark(e, index)}
                          value={examDetails?.full_marks}
                          placeholder={"Total Marks"}
                          disabled
                        />
                      </td>
                      <td className="text-center">
                        <input
                          type="number"
                          max={examDetails?.full_marks} // Enforces max value at input level
                          onChange={(e) => onChangeGainMarks(e, index)}
                          value={item.present_completed_paray}
                          placeholder={"Present Completed Paray"}
                          ref={(ref) => (inputRefs.current[index] = ref)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      </td>*/}

                        <td className="text-center">
                          <select
                            style={{ height: 40, width: "120px" }}
                            className="form-select"
                            name="status"
                            value={item.status}
                            onChange={(e) => onStatusChange(e, index)}
                            aria-label="Default select example"
                          >
                            <option value="Present">Present</option>
                            <option value="Absent">Absent</option>
                            <option value="Leave">Leave</option>
                          </select>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </Table>
          </div>
        )}

        {allExamList.length > 0 && (
          <div className="d-flex justify-content-end">
            <button
              disabled={updateloading ? true : false}
              className="btn btn-primary mx-2"
              onClick={updateResult}
            >
              {updateloading ? "Updating..." : "Update Exam Result"}
            </button>
          </div>
        )}
      </Paper>

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
      >
        <div
          className="p-3"
          style={{
            display: "flex",
            direction: "rtl",
            fontFamily: "'Jameel Noori Nastaleeq', serif",
            textAlign: "right",
          }}
        >
          <img style={{ height: 110, width: 100 }} src={icon} alt="logo" />

          <div className="col-md-8">
            <h1 className="text-center">{unitName}</h1>
            <h2 className="text-center">
              <b>
                {examDetails?.type == "Annual"
                  ? "سالانہ جائزہ پیش رفت: شعبہ حفظ القرآن"
                  : "ماہانہ جائزہ پیش رفت: شعبہ حفظ القرآن"}{" "}
              </b>
            </h2>
            <div className="d-flex justify-content-between">
              <h3>
                <b>کیمپس: {examDetails?.campus?.name}</b>
              </h3>
              <h3>
                <b>
                  کلاس (سیکشن): {examDetails?.student_class?.name} (
                  {examDetails?.global_section?.name})
                </b>
              </h3>
              <h3>
                <b> تاریخ: {currentDate} </b>
              </h3>
            </div>
          </div>
        </div>

        <Table
          dir="rtl"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
            border: "1px solid black",
            fontFamily: "'Jameel Noori Nastaleeq', serif",
          }}
        >
          <thead>
            <tr>
              <th style={headCellStyleVertical} rowspan="4">
                شمار نمبر
              </th>
              <th style={headCellStyleVertical} rowspan="4">
                ایڈمیشن نمبر
              </th>
              <th
                style={{ ...headCellStyle, paddingBottom: "70px" }}
                rowspan="4"
              >
                نام طالب علم بمعہ ولدیت
              </th>
              <th style={headCellStyleVertical} rowspan="4">
                تاحال تکمیل پارہ
              </th>
              <th style={headCellStyle} colspan="2">
                مجوزہ مقدار
              </th>
              <th style={headCellStyle} colspan="12">
                جائزہ رپورٹ کل نمبر (100)
              </th>
              <th style={headCellStyleVertical} rowspan="4">
                حاصل کردہ نمبر
              </th>
              <th style={headCellStyleVertical} rowspan="4">
                کیفیت
              </th>
            </tr>
            <tr>
              <th style={headCellStyleVertical} rowspan="3">
                سبقی پارہ
              </th>
              <th style={headCellStyleVertical} rowspan="3">
                منزل براۓ جائزہ
              </th>
              <th style={headCellStyleVertical} rowspan="3">
                تجوید (10)
              </th>
              <th style={headCellStyleVertical} rowspan="3">
                ترتیل (10)
              </th>
              <th style={headCellStyle} colspan="8">
                یاداشت (60)
              </th>
              <th style={headCellStyleVertical} rowspan="3">
                اخلاقی نصاب (10)
              </th>
              <th style={headCellStyleVertical} rowspan="3">
                ڈائری (10)
              </th>
            </tr>
            <tr>
              <th style={headCellStyle} colspan="2">
                سبق 1 (15)
              </th>
              <th style={headCellStyle} colspan="2">
                سبق 2 (15)
              </th>
              <th style={headCellStyle} colspan="2">
                سبق 3 (15)
              </th>
              <th style={headCellStyle} colspan="2">
                سبق 4 (15)
              </th>
            </tr>
            <tr>
              <th style={headCellStyleVertical}>اغلاط</th>
              <th style={headCellStyleVertical}>نمبر</th>
              <th style={headCellStyleVertical}>اغلاط</th>
              <th style={headCellStyleVertical}>نمبر</th>
              <th style={headCellStyleVertical}>اغلاط</th>
              <th style={headCellStyleVertical}>نمبر</th>
              <th style={headCellStyleVertical}>اغلاط</th>
              <th style={headCellStyleVertical}>نمبر</th>
            </tr>
          </thead>
          <tbody>
            {examDetails?.hifz_exam_results?.map((item, index) => (
              <tr key={item.id}>
                <td style={bodyCellStyle}>{index + 1}</td>
                <td style={bodyCellStyle}>{item?.student?.admission_id}</td>
                <td style={bodyCellStyle}>
                  {item?.student?.name?.length > 20
                    ? "..." + item.student.name.substring(0, 20)
                    : item.student?.name}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.present_completed_paray)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : item?.sabqi_para}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.manzal)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.tajweed)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.tarseel)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_one_mistakes)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_one_numbers)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_two_mistakes)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_two_numbers)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_three_mistakes)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_three_numbers)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_four_mistakes)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.lesson_four_numbers)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.moral_training)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.diary)}
                </td>
                <td style={bodyCellStyle}>
                  {printEmpty ? "" : Math.round(item?.total_marks)}
                </td>
                <td style={bodyCellStyle}>{printEmpty ? "" : item?.remarks}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Comfirmation SMS Modal Start*/}
      {/* <Modal show={sendTestMessageModal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Are you sure want to send test result message?
          </Modal.Title>
        </Modal.Header>
        {sendLoading ? (
          <div style={{ padding: "20px" }}>
            {" "}
            <b style={{ color: "green" }}>
              {" "}
              Message Sending Please Wait...{" "}
              <span className="spinner-borderd"></span>
            </b>
          </div>
        ) : (
          <Modal.Footer>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={sendSingleTestsSMS}
                className="btn button_blue"
                disabled={sendLoading ? true : false}
              >
                {sendLoading ? "Sending..." : "Send"}
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={() => setSendTestMessageModal(false)}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal> */}
      {/* Comfirmation SMS Modal End */}

      {/* Comfirmation Notification Modal Start*/}
      {/* <Modal show={notificationModal}>
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Are you sure want to send test result notification?
          </Modal.Title>
        </Modal.Header>
        {sendLoading ? (
          <div style={{ padding: "20px" }}>
            {" "}
            <b style={{ color: "green" }}>
              {" "}
              Message Sending Please Wait...{" "}
              <span className="spinner-borderd"></span>
            </b>
          </div>
        ) : (
          <Modal.Footer>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={sendNotification}
                className="btn button_blue"
                disabled={sendLoading ? true : false}
              >
                {sendLoading ? "Sending..." : "Send"}
              </button>
              <button
                style={{ marginLeft: "10px" }}
                onClick={() => setNotificationModal(false)}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        )}
      </Modal> */}
      {/* Comfirmation Notification Modal End */}
    </div>
  );
};

export default EnterHifzResult;
